import detectIncognito from "detectincognitojs";

export const isSafariPrivateMode = async (): Promise<boolean> => {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (!isSafari) return false; // if not safari return false here to avoid detectIncognito execution for non safari devices
  const { isPrivate } = await detectIncognito();
  return isPrivate;
};

export const isConsentCheckerAvailable = async () => {
  return !(process.env.NODE_ENV === 'development' || await isSafariPrivateMode());
}
